import React from 'react';
import Home from '../components/Home';
import About from '../components/About';
import Contact from '../components/Contact';
import SsHome from '../ss/SsHome';
import { APP_ID } from './appConfig';

export interface ScreenMap {
  Home: React.FC;
  About: React.FC;
  Contact: React.FC;
}

/**
 * The only APP_ID comparison outside appConfig. It lives here rather than in
 * appConfig so that appConfig stays a leaf module and
 * Home -> AppDownload -> appConfig cannot close an import cycle.
 */
// About and Contact are shared: they already read APP.brand.aboutIntro and
// APP.brand.contactEmail. They stay in the map so a future app can fork them
// without touching App.tsx.
const BM_SCREENS: ScreenMap = { Home, About, Contact };
const SS_SCREENS: ScreenMap = { Home: SsHome, About, Contact };

export const SCREENS: ScreenMap = APP_ID === 'ss' ? SS_SCREENS : BM_SCREENS;
